import type { RetirementDrop } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const getRetirementDropTotal = (drops: RetirementDrop[]): number =>
	drops
		.filter((drop) => drop.checked)
		.reduce((sum, drop) => sum + drop.amount, 0);
